module.exports = __webpack_public_path__ + "static/media/openApplication.67ef7d8d.svg";